module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pa-0"
  }, [_c('vue-gallery', {
    attrs: {
      "images": _vm.images,
      "index": _vm.index
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  }), _vm._v(" "), _vm._l((_vm.images), function(image, imageIndex) {
    return _c('div', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: ({
          src: image,
          error: '',
          loading: '../../static/img/preload.jpg'
        }),
        expression: "{\n        src: image,\n        error: '',\n        loading: '../../static/img/preload.jpg'\n      }",
        arg: "background-image"
      }],
      key: imageIndex,
      staticClass: "image-card",
      on: {
        "click": function($event) {
          _vm.index = imageIndex
        }
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ade941b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 314
// module chunks = 2